import $ from 'jquery';
import WishlistButtonEvents from '../../tracking/catalog/catalogWishlistButtonEvents';
import FilterEvents from '../../tracking/catalog/filterEvents';
import QuickViewEvents from '../../tracking/catalog/quickViewEvents';
import { register } from '../../core/bootstrapper';

register('category-new search-new', function() {
  $(document).ready(function() {
    if (typeof window.dataLayer !== 'undefined') {
      new FilterEvents({
        el: $('.js-list-view-form')
      });

      new QuickViewEvents({
        el: $('.js-article-list')
      });
    }
  });

  new WishlistButtonEvents();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/catalog/trackingBootstrap.js
 **/